import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./historyPanel.module.css";
import { formatDate } from "../../../../utils/arrayUtils";
import IMAGES from "../../../../assets/images/images";
import { toTitleCase } from "../../../../utils/utils";
import { Quotation_SUBTAB } from "../../../../utils/constants/DemandConstant";

export default function HistoryPanel({ onViewQuote, historyData,quotationId,activeTab }) {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const [collapse, setCollapse] = useState({});
    const close = useCallback(() => setOpen(false), []);
    const toggleDropdown = useCallback(() => { setOpen((v) => !v); }, []);

    useEffect(() => {
        if (!open) return;
        const onMouseDown = (e) => {
            if (!rootRef.current) return;
            if (!rootRef.current.contains(e.target)) close();
        };
        const onKeyDown = (e) => {
            if (e.key === "Escape") close();
        };
        document.addEventListener("mousedown", onMouseDown);
        document.addEventListener("keydown", onKeyDown);
        return () => {
            document.removeEventListener("mousedown", onMouseDown);
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [open, close]);

    return (
        <div ref={rootRef} className={styles.mainContainer}>
            <div className={styles.historyBtn}
                onClick={toggleDropdown}
                aria-expanded={open}
                aria-haspopup="dialog">
                History
            </div>
            {open && (
                <div className={styles.dropdown} role="dialog" aria-label="Quote history">
                    <div className={styles.header}>
                        <h3 className={styles.title}>{activeTab === Quotation_SUBTAB.FLOOR_PRICING ? "Floor Price History":"Quote History"}</h3>
                        <button
                            type="button"
                            className={styles.closeBtn}
                            onClick={close}
                            aria-label="Close">
                            <img className={styles.icon} src={IMAGES.close} alt="img"/>
                        </button>
                    </div>
                    <div className={styles.content}>
                        {(historyData || []).map((q, i) => {
                            return (
                                <div key={q.id} className={styles.card}>
                                    <button
                                        type="button"
                                        className={styles.cardHeader}
                                        onClick={() => setCollapse((prev) => ({ ...prev, [i]: !prev[i] }))}
                                        aria-expanded={i}
                                    >
                                        <div className={styles.cardHeaderLeft}>
                                            <span className={styles.quoteTitle}>{activeTab === Quotation_SUBTAB.FLOOR_PRICING ? "Floor Price V":"Quotation V"} {q.version}</span>
                                            <spn className={`${styles.status} ${styles[q?.status]}`}>{toTitleCase(q.status)}</spn>
                                        </div>
                                        <span className={styles.chevWrap} aria-hidden="true">
                                            <img className={`${styles.icon} ${!collapse[i]&&styles.rotate}`} src={IMAGES.arrowdown} alt="img"/>
                                        </span>
                                    </button>
                                    {!collapse[i] && (
                                        <div className={styles.cardBody}>
                                            <div className={styles.infoGrid}>
                                                <div className={styles.infoCell}>
                                                    <div className={styles.infoLabel}> Updated By: </div>
                                                    <div className={styles.infoValue} title={q.createdBy?.email}>{activeTab === Quotation_SUBTAB.FLOOR_PRICING?"Commercial Manager":"Account Manager"}</div>
                                                </div>
                                                <div className={styles.divider} />
                                                <div className={styles.infoCell}>
                                                    <div className={styles.infoLabel}>Submitted On:</div>
                                                    <div className={styles.infoValue}>{formatDate(q.createdAt)}</div>
                                                </div>
                                            </div>
                                            <div
                                                type="button"
                                                className={styles.viewBtn}
                                                onClick={() => onViewQuote?.(q)}
                                            >
                                                 {/* <img className={styles.icon} src={IMAGES.eyeicon} alt="img"/> */}
                                                 <span className={`${styles.eyeicon}`}><span className={`${ q.id === quotationId ? styles.showData : styles.hideData} ${styles.viewImage}` }></span></span>
                                                <span>View Quote</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}